import React from 'react';

const MainPage = () => {
    return (
        <div>
            <b>This is the react routers main page, which should never be displayed.</b><br/>
            If you are seeing this your middleware failed completely.<br />
            Probably you are doing something stupid in a constructor.<br />
            Maybe added a service recently?
        </div>
    );
};

export default MainPage;